import Service from '@root/common/base/Service';
import { ServiceInterface } from '@root/common/types/service';

import { GetUniversalHeadlines } from '@root/modules/headlines/types/headlines';
import getUniversalHeadlines from '@root/modules/headlines/graphql/getUniversalHeadlines.graphql';

type ServiceVariables = GetUniversalHeadlines['variables'];

type FetchVariables = GetUniversalHeadlines['variables'];

type Response = GetUniversalHeadlines['data'];

// TODO: unify getMostReadArticles with UniversalHeadlines (they are basically the same query)
export default class UniversalHeadlinesService extends Service implements ServiceInterface {
  private async fetchUniversalHeadlines(variables: FetchVariables) {
    try {
      const apiProvider = this.createProvider('GraphQL');
      apiProvider
        .selectAPI('content-api-v3')
        .setLinkOptions({ useAutomaticPersistedQueries: true, useGETAutomaticPersistedQueries: true })
        .setCacheOptions({ key: `fetchUniversalHeadlines:${JSON.stringify(variables)}`, ttl: 30 })
        .enableCache(true);

      const options = Object.assign({ query: getUniversalHeadlines }, { variables });
      const response = await apiProvider.request<Response>(options);

      return {
        items: response.headlines?.items || [],
        pager: response.headlines.pager,
      };
    } catch {
      return {
        items: [],
        pager: {
          offset: 0,
          count: 0,
        },
      };
    }
  }

  public async fetch(variables: ServiceVariables) {
    const isHealthy = this.getHealthCheckStatus('content-api-v3');

    if (!isHealthy) {
      return {
        items: [],
        pager: {
          offset: 0,
          count: 0,
        },
      };
    }

    const response = await this.fetchUniversalHeadlines(variables);

    return response;
  }
}
